export default "__VITE_PUBLIC_ASSET__0fd008c8__"